<template>
    <div class="article-wrapper">
        <ul class="breadcrumbs" v-if="post.group.type === '5'">
            <li>
                <router-link :to="{ name: 'view-group', params: { group: post.group.slug }}">
                    {{ post.group.name }}
                </router-link>
            </li>
            <li>
                {{ post.title }}
            </li>
        </ul>

        <div class="panel">
            <div class="article">
                <h1>{{ post.title }}</h1>
                
                <div class="byline">
                    <avatars :users="post.authors" v-if="post.authors"></avatars>

                    <div>
                        <router-link v-if="post.group.slug" :to="{ name: 'view-group', params: { group: post.group.slug } }">{{ post.group.name }}</router-link> on {{ formatDate(post.published_at) }}
                    </div>
                </div>

                <div v-html="post.content" class="article__content"></div>

                <event-card :post="post" v-if="post.group.type === '4'"></event-card>
            </div>

            <div class="reactions-form">
                <button class="btn btn-small" :class="(post.reactions.user_thumbs_up)?'active':''" v-on:click.stop.prevent="toggleReaction(1)">
                    👍 <span>{{ post.reactions.thumbs_up }}</span>
                </button>
                <button class="btn btn-small" :class="(post.reactions.user_clap)?'active':''" v-on:click.stop.prevent="toggleReaction(2)">
                    👏 <span>{{ post.reactions.clap }}</span>
                </button>
                <button class="btn btn-small" :class="(post.reactions.user_love)?'active':''" v-on:click.stop.prevent="toggleReaction(3)">
                    😍 <span>{{ post.reactions.love }}</span>
                </button>

                <button class="btn btn-small btn-print" v-on:click.stop.prevent="print()">
                    <i class="icon ion-md-print"></i>
                </button>
            </div>
        </div>
        <div class="panel" :class="(post.comments_count === 0)?'no-comments':''">
            <comments :comments="post.comments" :commentsCount="post.comments_count"></comments>
        </div>
    </div>
</template>

<script>
    import { format, parse } from 'date-fns';
    export default {
        props: ['post'],
        data(){
            return {
                reactionURL: '/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post + "/reactions",
            }
        },
        methods: {
            print(){
                window.print();
            },
            formatDate(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    return format(date, 'do LLL yyyy HH:mm');
                }
            },
            toggleReaction(reaction){
                var reactions = {
                    1 : 'thumbs_up',
                    2 : 'clap',
                    3 : 'love'
                };

                if( this.post.reactions['user_' + reactions[reaction]] ){
                    axios.delete(this.reactionURL + "/" + reaction).then((response) => {
                        this.post.reactions[reactions[reaction]]--;
                        this.post.reactions['user_' + reactions[reaction]]--;
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.post(this.reactionURL, {type: reaction}).then((response) => {
                        this.post.reactions[reactions[reaction]]++;
                        this.post.reactions['user_' + reactions[reaction]]++;
                    }, (response) => {
                        this.error = response;
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
    .article-wrapper .breadcrumbs{
        margin-bottom: 20px;
    }
</style>